import { DietOptions, OriginOptions } from "../nutrition/nutritionSlice";

import MediterranianImg from "common/img/diet-type-mediterranian.jpg";
import VegetarianImg from "common/img/diet-type-vegetarian.jpg";
import VeganImg from "common/img/diet-type-vegan.jpg";

interface DietOption {
  label: string;
  value: DietOptions;
  img: string;
}

export const DIET_OPTIONS: DietOption[] = [
  {
    label: "Mediterránea",
    value: "mediterranian",
    img: MediterranianImg,
  },
  {
    label: "Vegetariana",
    value: "vegetarian",
    img: VegetarianImg,
  },
  {
    label: "Vegana",
    value: "vegan",
    img: VeganImg,
  },
];

interface OriginOption {
  label: string;
  value: OriginOptions;
}

export const ORIGIN_OPTIONS: OriginOption[] = [
  {
    label: "Locales",
    value: "local",
  },
  {
    label: "Nacionales",
    value: "national",
  },
  {
    label: "Internacionales",
    value: "international",
  },
];
